import { Component, HostListener, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PubnubService } from '../services/Pubnub.service';
import { ActivatedRoute } from '@angular/router';
import { Map, getInstance, UserData, UserType } from 'nextnavsdk';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-mobile2cad',
    // standalone: true,
    // imports: [],
    templateUrl: './mobile2cad.component.html',
    styleUrl: './mobile2cad.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Mobile2cadComponent implements OnInit {
  environment = environment;
  pubChannelId = "get-updates";
  subChannelId = "";
  incidentId: string = "";
  incidentStarted: boolean = false;
  pinnacleInterface: any;
  nextnavMap: any;
  constructor(private http: HttpClient, private route: ActivatedRoute, private pubnub: PubnubService) {

  }
  // @HostListener('window:beforeunload', ['$event'])
  //   unloadNotification($event: any) {
  //     this.btn_stop_click()
  //   }
  svgToDataURL(svg: any) {
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
  }
  createSVGIconWithText(text: any) {
    if (text == "")
      return `
<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="12" r="12" fill="#ffffff" stroke="#5EB2E1" stroke-width="1"/>
<circle cx="12" cy="12" r="8" fill="#ff0000" stroke="#ff0000" stroke-width="1"/>
</svg>
`;
    else return `
<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="12" r="9" fill="rgb(255, 255, 255)" stroke="black" stroke-width="1"/>
<text x="5" y="16" fill="black" font-weight="bold" font-size="9" font-family="Verdana">` + text + `</text>
</svg>
`;
  }

  position: any = {};
  firstLoad: boolean = true;
  btn_start_click() {
    if ($('#txt_id_addr').val().trim().length == 0) {
      alert("Please Enter incident name");
      return;
    }
    this.incidentStarted = true;
    this.firstLoad = true;
    let _this = this;
    let msg = {
      "IncidentAction": 1,
      "IncidentName": this.incidentId,
      "ChannelName": this.incidentId
    }
    this.pubnub.publish(this.pubChannelId, msg);
    this.pubnub.addShowCaseListners(this.incidentId);
    this.pubnub.addObserver(this.incidentId).subscribe(async (obj: any) => {
      console.log(obj);
      if (obj.channel != "get-updates")
        if (_this.pinnacleInterface.isLoaded) {
          if (_this.firstLoad)
            if (obj.message) if (obj.message.location2d) if (obj.message.location2d.latitude && obj.message.location2d.longitude) {
              _this.nextnavMap.setLocation({ lat: Number(obj.message.location2d.latitude), lng: Number(obj.message.location2d.longitude), zoom: 18, orientation: 0 });
              _this.firstLoad = false;
            }
          let userType = null;
          if (obj.message && obj.message.type)
            userType = obj.message.type;
          if (obj.publisher) {
            let img = null;
            let userTypeEnum = null;
            if (userType == 2) {
              img = './assets/police.png';
              userTypeEnum = UserType.POLICE;
            }
            else if (userType == 1) {
              img = './assets/firefighter.png';
              userTypeEnum = UserType.FIREFIGHTER;
            }
            else if (userType == 3) {
              img = './assets/ems.png';
              userTypeEnum = UserType.EMS;
            }
            else if (userType == 4) {
              img = './assets/security.png';
              userTypeEnum = UserType.SECURITY;
            }
            else if (userType == 5) {
              img = './assets/e911caller.png';//_this.svgToDataURL(_this.createSVGIconWithText(""));
              userTypeEnum = UserType.E911USER;
            }
            else {
              img = './assets/man.png';
              userTypeEnum = UserType.OTHER;
            }
            if (!_this.position[obj.publisher] && obj.message.location2d) {
              _this.position[obj.publisher] = new UserData({
                id: obj.publisher,
                userType: userTypeEnum, imgPath: img, lat: obj.message.location2d.latitude,
                lng: obj.message.location2d.longitude,
                hat: obj.message.isLocationUserPinned ? 1 : obj.message.heightAboveTerrain,
                // efl: obj.message.isLocationUserPinned ? 0 : ((obj.message.estimatedFloorValue == 0 || obj.message.estimatedFloorValue) ? obj.message.estimatedFloorValue : Math.round(obj.message.heightAboveTerrain / 3)),
                firstName: obj.message.firstName,
                lastName: obj.message.lastName,
                timestamp: obj.message.timestamp
              });
              _this.pinnacleInterface.addUser(_this.position[obj.publisher]);
            }

            if (_this.position[obj.publisher]) {
              if (obj.message && obj.message.location2d && obj.message.location2d.latitude && obj.message.location2d.longitude) {
                obj.message.heightAboveTerrain = obj.message.heightAboveTerrain ? obj.message.heightAboveTerrain : 0;
                if (isFinite(obj.message.location2d.latitude) && Math.abs(obj.message.location2d.latitude) <= 90 && Math.abs(obj.message.location2d.longitude) <= 180 && Math.abs(obj.message.location2d.longitude) <= 180 && isFinite(obj.message.heightAboveTerrain)) {
                  _this.pinnacleInterface.updateUserLocation({
                    id: obj.publisher,
                    lat: obj.message.location2d.latitude,
                    lng: obj.message.location2d.longitude,
                    // hat: obj.message.heightAboveTerrain,
                    // hae: Number.NaN,
                    hat: obj.message.isLocationUserPinned ? 1 : obj.message.heightAboveTerrain,
                    // efl: obj.message.isLocationUserPinned ? 0 : ((obj.message.estimatedFloorValue == 0 || obj.message.estimatedFloorValue) ? obj.message.estimatedFloorValue : Math.round(obj.message.heightAboveTerrain / 3)),
                    userType: userTypeEnum,
                    imgPath: img,
                    // firstName: obj.message.firstName,
                    // lastName: obj.message.lastName,
                    timestamp: obj.message.timestamp
                  });
                }
              }
            }
          }
          // console.log(obj.timeout);
          if (obj.timeout) {
            if (_this.position && _this.position[obj.publisher]) {
              _this.pinnacleInterface.removeUser(obj.publisher);
              delete _this.position[obj.publisher];
            }
          }
        }
    });
  }
  btn_stop_click() {
    let _this = this;
    let msg = {
      "IncidentAction": 0,
      "IncidentName": this.incidentId,
      "ChannelName": this.incidentId
    }
    this.pubnub.publish(this.pubChannelId, msg);
    this.pubnub.leaveChannel(this.incidentId);
    if (this.position) {
      let objKeys = Object.keys(this.position);
      objKeys.forEach(key => {
        _this.pinnacleInterface.removeUser(key);
        delete _this.position[key];
      });
    }
    this.incidentStarted = false;
    $('#txt_id_addr').val('');
  }
  openM2CDialog() {
    $("#btn_m2ccontrol i").addClass('active');
    $("#m2c_dialog").dialog('open');
  }
  ngOnInit(): void {
    $("#m2c_dialog")
      .dialog({
        "title": 'M2C Control',
        autoOpen: false,
        height: 170,
        width: 250,
        resizable: false,
        position: { my: "right bottom", at: "right+70 bottom", of: '#btn_m2ccontrol' },
        close: function (event: any, ui: any) {


        },
        show: { effect: "slide", duration: 500 },
        hide: { effect: "drop", duration: 500 },
      })
    let defaultLat = 39.8097343;
    let defaultLng = -98.5556199;
    var _this = this;
    this.pinnacleInterface = getInstance('f5CWhIHdcN5EjXhLVUOmM9AeBihSQeXr8DHuLfjf');
    this.pinnacleInterface.on('load', function (event: any) {
      _this.nextnavMap = new Map('container', {
        mapOptions: {
          //center: [0, 1],
          zoom: 15
        }
      });
    });
    _this.pubnub.showCasePubnumInstantiateAndSubscribe(environment.mob2cadpubKey, environment.mob2cadsubkey, "get-updates", "test");
    if (_this.pinnacleInterface.isLoaded)
      _this.pinnacleInterface.setMapLocation({ lat: defaultLat, lng: defaultLng, zoom: 4, orientation: 0 });
    else
      _this.pinnacleInterface.on('load', function (event: any) {
        _this.pinnacleInterface.setMapLocation({ lat: defaultLat, lng: defaultLng, zoom: 4, orientation: 0 });
      });
  }
}